<script setup>
import {useAsyncData, useRoute} from 'nuxt/app'
import SourceCtasBlockComponent from '~/components/pages/blocks/SourceCtasBlockComponent.vue'
import TextPhotoCtaBlockComponent from '~/components/pages/blocks/TextPhotoCtaBlockComponent.vue'
import ShapoGoogleReviewsBlockComponent from '~/components/pages/blocks/ShapoGoogleReviewsBlockComponent.vue'
import KeyItemsBlockComponent from '~/components/pages/blocks/KeyItemsBlockComponent.vue'
import LinkItemsBlockComponent from '~/components/pages/blocks/LinkItemsBlockComponent.vue'
import {usePageApi} from '~/composables/api/usePageApi'
import {getPageTitle} from '~/utils/seoUtils'

const asyncComponents = {
  //'SliderBlock': () => import('~/components/pages/blocks/SliderBlockComponent.vue'),
  //'MosaicCtasBlock': () => import('~/components/pages/blocks/MosaicCtasBlockComponent.vue'),
  'SourceCtasBlock': SourceCtasBlockComponent,
  'TextPhotoCtaBlock': TextPhotoCtaBlockComponent,
  'ShapoGoogleReviewsBlock': ShapoGoogleReviewsBlockComponent,
  'KeyItemsBlock': KeyItemsBlockComponent,
  'LinkItemsBlock': LinkItemsBlockComponent
}
const config = useRuntimeConfig()
const currentRoute = useRoute()

const pageBlocks = computed(() => {
  return data.value?.blocks || []
})

const {data, error} = await useAsyncData('index-page', async () => {
  const pageApi = usePageApi()
  return await pageApi.getBySlug(currentRoute.path)
})

if (error.value) {
  throw createError({statusCode: 404, statusMessage: 'page_not_found', fatal: true})
}

useHead({
  title: getPageTitle(data.value.seo.title, config.public.pageTitle),
  meta: [
    {
      name: 'description',
      content: data.value.seo.description
    },
    {
      name: 'robots',
      content: data.value.seo.robots
    }
  ]
})

function getBlockComponent(block) {
  return asyncComponents?.[block.type]
}
</script>

<template>
  <div class="grid grid-cols-12">
    <template v-for="block in pageBlocks" :key="block.id">
      <component :is="getBlockComponent(block)" :data="block"/>
    </template>
  </div>
</template>
